import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'
import { Athlete } from 'src/services/types/athlete'
import { AthleteAchievementsRes } from 'src/services/types/getAthleteAchievements'

// import { athleteProfileAPI } from './athleteProfileAPI';
// import { logout, updateUserData } from '../user/userDuck';
// import { showToastSuccess, showToastError } from 'common/utils';
// import moment from 'moment';
// import { userAPI } from '../user/userAPI';

// export const getAthleteProfile = createAsyncThunk(
//     'atheleteProfile/getAtheleteProfile',
//     async (_, { getState, rejectWithValue, dispatch }) => {
//         try {
//             const state = getState();
//             const response = await athleteProfileAPI.fetchProfile(
//                 state.user.data.userName,
//             );
//             return response;
//         } catch (e) {
//             if (e.message.includes('Network')) {
//                 return rejectWithValue(e);
//             } else {
//                 dispatch(logout());
//                 showToastError('Please login again');
//                 return rejectWithValue(e);
//             }
//         }
//     },
// );

// export const updateProfile = createAsyncThunk(
//     'atheleteProfile/updateProfile',
//     async (userData, { rejectWithValue, getState, dispatch }) => {
//         try {
//             const state = getState();
//             const response = await athleteProfileAPI.update(
//                 userData,
//                 state.user,
//             );

//             if (response.logout) {
//                 const refreshResponse = await userAPI.refreshUser();
//                 dispatch(updateUserData(refreshResponse));
//             }

//             return response;
//         } catch (e) {
//             return rejectWithValue(e);
//         }
//     },
// );

// export const deleteAvatar = createAsyncThunk(
//     'atheleteProfile/deleteAvatar',
//     async (athleteId, { rejectWithValue }) => {
//         try {
//             const response = await athleteProfileAPI.deleteAvatar(athleteId);
//             return response;
//         } catch (e) {
//             return rejectWithValue(e);
//         }
//     },
// );

// export const connectAthleteProfile = createAsyncThunk(
//     'atheleteProfile/connect',
//     async (data, { rejectWithValue }) => {
//         try {
//             const response = await athleteProfileAPI.connectAthleteProfile(
//                 data,
//             );
//             return response;
//         } catch (e) {
//             return rejectWithValue(e);
//         }
//     },
// );

// export const disconnectAthleteProfile = createAsyncThunk(
//     'atheleteProfile/disconnect',
//     async (athleteId, { rejectWithValue }) => {
//         try {
//             const response = await athleteProfileAPI.disconnectAthleteProfile(
//                 athleteId,
//             );
//             return response;
//         } catch (e) {
//             return rejectWithValue(e);
//         }
//     },
// );

// export const fetchFriends = createAsyncThunk(
//     'atheleteProfile/social/fetchFriends',
//     async (socialData, { rejectWithValue }) => {
//         try {
//             const response = await athleteProfileAPI.fetchFriends(socialData);
//             return response;
//         } catch (e) {
//             return rejectWithValue(e);
//         }
//     },
// );

// export const connectFriends = createAsyncThunk(
//     'atheleteProfile/social/connectFriends',
//     async (socialData, { rejectWithValue }) => {
//         try {
//             const response = await athleteProfileAPI.connectFriends(socialData);
//             return response;
//         } catch (e) {
//             return rejectWithValue(e);
//         }
//     },
// );

// export const connectGroup = createAsyncThunk(
//     'atheleteProfile/social/connectFriends',
//     async (socialData, { rejectWithValue }) => {
//         try {
//             const response = await athleteProfileAPI.connectGroup(socialData);
//             return response;
//         } catch (e) {
//             return rejectWithValue(e);
//         }
//     },
// );

interface AthleteState {
    data: Omit<Athlete, 'user'>
    user: Athlete['user']
    achievements: AthleteAchievementsRes
    unsubscribedTopics: any[]
    fbExistingAccessToken: string | null
}

const initialState = {
    data: null,
    user: null,
    achievements: null,
    unsubscribedTopics: [],
    fbExistingAccessToken: null
} as AthleteState

const athleteProfileSlice = createSlice({
    name: 'athleteProfile',
    initialState,
    reducers: {
        updateAthleteData(state, action: PayloadAction<Athlete>) {
            const withoutUserObj = { ...action.payload }
            delete withoutUserObj.user

            state.user = action.payload.user
            state.data = withoutUserObj
        },
        updateAthleteAchievements(state, action: PayloadAction<AthleteAchievementsRes>) {
            state.achievements = action.payload
        },
        resetAthleteData(state) {
            state.data = initialState.data
            state.user = initialState.user
        }
    },
    extraReducers: {
        [HYDRATE]: (state, action: PayloadAction<any>) => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return {
                ...state,
                ...action.payload.athleteProfile
            }
        }
    }
    // extraReducers: {
    //     // Add reducers for additional action types here, and handle loading state as needed
    //     [getAthleteProfile.pending]: (state, action) => {
    //         state.fetching = true
    //         state.error = null
    //     },
    //     [getAthleteProfile.fulfilled]: (state, action) => {
    //         state.data = action.payload
    //         state.unsubscribedTopics = action.payload.unsubscribedTopics
    //         state.fetching = false
    //     },
    //     [getAthleteProfile.rejected]: (state, action) => {
    //         state.error = action.payload?.message
    //         state.fetching = false
    //     },
    //     [updateProfile.pending]: (state, action) => {
    //         state.updatePending = true
    //         state.error = null
    //     },
    //     [updateProfile.fulfilled]: (state, action) => {
    //         showToastSuccess('Your info has been saved')
    //         state.data = action.payload.athlete
    //         state.updatePending = false
    //     },
    //     [updateProfile.rejected]: (state, action) => {
    //         showToastError(action.payload?.message)
    //         state.error = action.payload?.message
    //         state.updatePending = false
    //     },
    //     [deleteAvatar.fulfilled]: (state, action) => {
    //         state.deleteAvatar.data = action.payload?.message
    //         state.deleteAvatar.error = false
    //     },
    //     [deleteAvatar.rejected]: (state, action) => {
    //         state.deleteAvatar.data = action.payload?.message
    //         state.deleteAvatar.error = true
    //     },
    //     [connectAthleteProfile.pending]: (state, action) => {
    //         state.connectionPending = true
    //         state.error = null
    //     },
    //     [connectAthleteProfile.fulfilled]: (state, action) => {
    //         showToastSuccess('Your accounts have successfully been connected.')
    //         ;(state.data = {
    //             ...state.data,
    //             user: {
    //                 ...state.data.user,
    //                 facebookUserId: action.payload.facebookUserId,
    //                 fbAccessToken: action.payload.fbAccessToken,
    //                 isFacebookUser: true
    //             }
    //         })((state.connectionPending = false))
    //     },
    //     [disconnectAthleteProfile.pending]: (state, action) => {
    //         state.disconnectionPending = true
    //         state.error = null
    //     },
    //     [disconnectAthleteProfile.fulfilled]: (state, action) => {
    //         showToastSuccess('Your account has successfully been disconnected.')
    //         ;(state.data = {
    //             ...state.data,
    //             user: {
    //                 ...state.data.user,
    //                 facebookUserId: null,
    //                 fbAccessToken: null,
    //                 isFacebookUser: false
    //             }
    //         })((state.disconnectionPending = false))
    //     },
    //     [fetchFriends.pending]: (state, action) => {
    //         state.loading = true
    //         state.error = null
    //     },
    //     [fetchFriends.fulfilled]: (state, action) => {
    //         state.social = {
    //             athleteFacebookFriends: action.payload.facebookResponse,
    //             athleteConnections: {
    //                 data: action.payload.athleteConnections
    //             },
    //             socialProfile: action.payload.socialProfile,
    //             groups: action.payload.groups,
    //             userName: action.payload.userName,
    //             isMe: action.payload.isMe,
    //             hasError: false,
    //             isLoading: false,
    //             isLoaded: true,
    //             error: null,
    //             lastUpdated: moment().format('h:mm A'),
    //             refresh: false,
    //             inviteAthlete: false
    //         }
    //     }
    // }
})

const { actions } = athleteProfileSlice
// Extract and export each action creator by name
export const { updateAthleteData, resetAthleteData, updateAthleteAchievements } = actions
// Export the reducer, either as a default or named export
export default athleteProfileSlice
